//region block: pre-declaration
//endregion
function canRead(_this__u8e3s4) {
  return !_this__u8e3s4.v3z();
}
//region block: exports
export {
  canRead as canRead1guo8vbveth0f,
};
//endregion

//# sourceMappingURL=Buffer.mjs.map
